import React, { useState } from 'react'
import PropTypes from 'prop-types'
import AccordionItem from './AccordionItem'
import {
  AccordionWrapper,
  AccordionHeader,
  AccordionTitle,
  ToggleButton,
} from './style'
const Accordion = ({ title, data }) => {
  const [expandAll, setExpandAll] = useState(false)
  function toggleExpaned() {
    setExpandAll(!expandAll)
  }
  return (
    <AccordionWrapper>
      <AccordionHeader>
        <AccordionTitle>{title}</AccordionTitle>
        <ToggleButton
          onClick={() => toggleExpaned()}
          autoFocus={true}
          aria-label={
            expandAll
              ? `Close allbutton, to close all ${title} accordion item double click here`
              : `Open all button, to open all ${title} accordion item double click here`
          }
        >
          {expandAll ? 'Close all' : 'Open all'}
        </ToggleButton>
      </AccordionHeader>
      {data.map((item, index) => (
        <AccordionItem
          key={index}
          item={item}
          ariaExpanded={expandAll}
          ariaControls={`${title}-${index}`}
          ariaId={`accordion-${title}-${index}`}
        />
      ))}
    </AccordionWrapper>
  )
}

Accordion.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array,
}

export default Accordion
